// extracted by mini-css-extract-plugin
export var avatarContainer = "_3u-0";
export var gray = "_3u-f";
export var green = "_3u-c";
export var icon = "_3u-9";
export var image = "_3u-1";
export var lg = "_3u-6";
export var md = "_3u-5";
export var presenceDot = "_3u-b";
export var red = "_3u-d";
export var sm = "_3u-4";
export var status = "_3u-a";
export var xl = "_3u-7";
export var xs = "_3u-3";
export var xxl = "_3u-8";
export var xxs = "_3u-2";
export var yellow = "_3u-e";